import ClaimDetailsTable from './ClaimDetailsTable';

export default ClaimDetailsTable;
